import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './styles/App.css';
import Lander from './pages/Lander';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Lander/>} />
        </Routes>
      </BrowserRouter>
      <ToastContainer theme="colored" draggable pauseOnHover autoClose={5000}/>
    </div>
  );
}

export default App;
